<script setup>
import { computed } from "vue";
import { siteCopy } from "../data/content";
import BrandMark from "./BrandMark.vue";
import IconArrow from "./IconArrow.vue";

const props = defineProps({
  locale: { type: String, required: true },
  copy: { type: Object, required: true },
});

const nav = computed(() => siteCopy[props.locale].nav);
const home = computed(() => `/${props.locale}`);
const year = new Date().getFullYear();
const socialLinks = [
  { name: "Instagram", handle: "@resicorporation", href: "https://www.instagram.com/resicorporation/" },
  { name: "TikTok", handle: "@resi.corporation", href: "https://www.tiktok.com/@resi.corporation" },
  { name: "Facebook", handle: "Resi Corporation", href: "https://www.facebook.com/profile.php?id=61575279148019&locale=es_LA" },
];
</script>

<template>
  <footer class="site-footer">
    <div class="shell footer-grid">
      <div class="footer-intro">
        <RouterLink class="brand-link" :to="home" aria-label="Resi Corporation"><BrandMark /></RouterLink>
        <p class="eyebrow">{{ copy.eyebrow }}</p>
      </div>
      <div class="footer-statement">
        <p>{{ copy.phrase }}</p>
        <RouterLink class="button button--primary footer-cta" :to="`${home}#contact`">
          {{ nav.contact }}<IconArrow />
        </RouterLink>
      </div>
    </div>

    <div class="shell footer-directory">
      <nav class="footer-nav" :aria-label="copy.navigation">
        <p>{{ copy.navigation }}</p>
        <RouterLink :to="`${home}#services`">{{ nav.services }}</RouterLink>
        <RouterLink :to="`${home}#projects`">{{ nav.projects }}</RouterLink>
        <RouterLink :to="`${home}#process`">{{ nav.process }}</RouterLink>
        <RouterLink :to="`${home}/associates`">{{ nav.associates }}</RouterLink>
        <RouterLink :to="`${home}/blog`">{{ nav.blog }}</RouterLink>
      </nav>

      <div class="footer-contact">
        <p>{{ copy.contact }}</p>
        <a href="mailto:resicorporation@gmail.com">resicorporation@gmail.com<IconArrow /></a>
        <span>{{ copy.availability }}</span>
      </div>

      <div class="footer-social">
        <p>{{ copy.social }}</p>
        <a v-for="social in socialLinks" :key="social.name" :href="social.href" target="_blank" rel="noreferrer">
          <span><strong>{{ social.name }}</strong><small>{{ social.handle }}</small></span>
          <IconArrow />
        </a>
      </div>
    </div>

    <div class="footer-monogram" aria-hidden="true">RESI</div>

    <div class="shell footer-base">
      <span>© {{ year }} Resi Corporation. {{ copy.rights }}</span>
      <span>Buenos Aires · Argentina</span>
    </div>
  </footer>
</template>
